// I tipi che il tavolo del tressette legge. La TMA NON importa QTressette: sono COPIATI A MANO da Qlash-IT/QTressette @ f5e52710a56931b2a55b116f703aa5399ffd34f8
// (main, 2026-10-23), uno per file:
//   · Posto, Linea, Config, Fase, Segno, Giocata, Presa, Accuso, Pescata, SegnoDetto, Riepilogo, Vista — packages/regole/src/tipi.ts (blob ec0d963132de). La Vista e
//     quella del motore (`vista()`): MAI la mano di un altro posto (il compagno compreso), MAI l'ordine del tallone, MAI le carte prese, MAI i punti della smazzata in corso, MAI gli
//     accusi di un posto prima della sua prima carta. Degli altri si sa solo QUANTE carte hanno (`carteInMano`). `Stato`, `Azione`, `Rifiuto` ed `EsitoPartita` del motore NON si copiano (l'esito arriva nel `table:state` come `EsitoPerLinea` del trasporto, `lib/gamehost/protocol.ts`; di `dettaglio` si legge solo `come`, v. `ComeFinita`): sono del
//     server; di `Azione` resta la sola mossa di una persona, `GIOCA`. Il tipo `Carta` e il suo (`@qlash-it/gamekit-carte`): un intero 0..39, `seme * 10 + grado - 1`, semi
//     denari, coppe, spade, bastoni (la stessa codifica della scopa e della briscola: la disegna la `Carta` del modulo tavolo).
//   · ORDINE_DI_PRESA — packages/regole/src/ordine.ts (blob 3e599cf10e2b): 3, 2, A, R, C, F, 7, 6, 5, 4. Serve SOLO a mettere in ordine la mano che si vede (`ordinaMano` di `lib/tressette/disposizione.ts`, che usa `ordinaPerSeme` del modulo tavolo; la copia sta li): la legalita
//     e di chi decide, il game host.
//   · AzioneDiPersona — packages/regole/src/tipi.ts `Azione` (`GIOCA`) + apps/qtressette-gameserver/src/regole.ts `puòAgire` (blob fe05ae271587): le chiavi sono ESATTAMENTE `carta`,
//     `posto`, `t`, e `segno` solo per chi apre la presa nel 2v2 (un'altra chiave e `AZIONE_MALFORMATA`); `DISTRIBUISCI`, `RACCOGLI`, `UFFICIO` e `ABBANDONO` sono del server.
//   · MOTIVI — apps/qtressette-gameserver/src/regole.ts `MOTIVI` (i sotto-codici che un rifiuto puo portare in `reason`).
// Del trasporto (la busta di stato, gli eventi, la mescolata verificabile) NON c'e niente qui: e `src/lib/gamehost/protocol.ts`.

/** Un posto (0..3) e una linea (chi segna insieme: il giocatore nel 1v1, la coppia {0,2} o {1,3} nel 2v2). */
export type Posto = number;
export type Linea = number;
/** Una carta e un intero 0..39: `seme * 10 + grado - 1`. */
export type Carta = number;
export type Fase = 'da-distribuire' | 'in-gioco' | 'finita';

export interface Config {
  /** il traguardo della partita, in punti: 21 (L-3438). Vince la linea che ci arriva per prima col «vinco subito». */
  readonly obiettivo: number;
  /** le carte di ogni mano: 10, fisso */
  readonly carte: number;
  /** dopo quante mosse d'ufficio CONSECUTIVE dello stesso posto c'e l'abbandono (tempo scaduto = partita persa) */
  readonly ufficioMax: number;
  readonly classificato: boolean;
  readonly turnoMs?: number;
  readonly raccogliMs?: number;
}

/** Il segno di chi apre la presa, nel 2v2 (L-3440): pubblico, scelto dal giocatore. */
export type Segno = 'busso' | 'striscio' | 'volo';
/** I tre segni, nell'ordine in cui il tavolo li offre. */
export const SEGNI: readonly Segno[] = ['busso', 'striscio', 'volo'];

/** Una carta giocata in una presa, con chi l'ha giocata. */
export interface Giocata {
  readonly posto: Posto;
  readonly carta: Carta;
}

/** Una presa chiusa: le carte nell'ordine di gioco e chi l'ha vinta. */
export interface Presa {
  readonly giocate: readonly Giocata[];
  readonly vincitore: Posto;
}

/**
 * Un accuso annunciato (L-3439), pubblico: chi, che cosa, quanto vale. La napoletana dice il seme (asso, 2 e 3 di quel seme); il buongioco il grado (1, 2 o 3) e i semi delle
 * carte che lo fanno (tre o quattro).
 */
export type Accuso =
  | { readonly posto: Posto; readonly tipo: 'napoletana'; readonly seme: number; readonly punti: number }
  | { readonly posto: Posto; readonly tipo: 'buongioco'; readonly grado: number; readonly semi: readonly number[]; readonly punti: number };

/** Una carta pescata dal tallone nel 1v1: pubblica, col posto che l'ha pescata e la presa dopo cui l'ha pescata (0 = la prima). */
export interface Pescata {
  readonly posto: Posto;
  readonly carta: Carta;
  readonly presa: number;
}

/** Un segno detto nel 2v2: chi l'ha detto, in quale presa (0 = la prima della smazzata), quale. */
export interface SegnoDetto {
  readonly posto: Posto;
  readonly presa: number;
  readonly segno: Segno;
}

/** Il conto di una smazzata, pubblico da quando e finita (o interrotta dal «vinco subito»). */
export interface Riepilogo {
  readonly smazzata: number;
  readonly mazziere: Posto;
  /** i terzi presi da ogni linea: sommano 32 a smazzata completa */
  readonly terzi: readonly number[];
  /** la linea che ha fatto l'ultima presa, o null se la smazzata si e interrotta prima */
  readonly ultima: Linea | null;
  /** i punti delle prese di ogni linea: floor(terzi / 3), piu 1 a chi ha fatto l'ultima. A smazzata completa sommano 11 */
  readonly prese: readonly number[];
  /** i punti degli accusi di ogni linea */
  readonly accusi: readonly number[];
  /** prese piu accusi, per linea */
  readonly punti: readonly number[];
  /** la linea che ha chiuso la partita col «vinco subito» (arrivata al traguardo appena dopo una sua presa, anche l'ultima), o null */
  readonly vintaSubito: Linea | null;
}

/** Quello che UN posto vede. Nessun campo porta i punti della smazzata in corso ne la mano di un altro posto. */
export interface Vista {
  readonly posto: Posto;
  readonly linea: Linea;
  readonly posti: number;
  readonly config: Config;
  readonly fase: Fase;
  readonly smazzata: number;
  readonly mazziere: Posto;
  readonly turno: Posto;
  readonly miaMano: readonly Carta[];
  /** quante carte ha in mano ogni posto (anche il proprio) */
  readonly carteInMano: readonly number[];
  /** quante carte restano nel tallone (1v1; 0 nel 2v2) */
  readonly tallone: number;
  /** la presa in corso; completa (tanti quanti i posti) = da raccogliere, e `turno` e gia chi la vince */
  readonly presa: readonly Giocata[];
  readonly ultimaPresa: Presa | null;
  /** le carte uscite in questa smazzata, in ordine, senza chi le ha giocate ne chi le ha prese (la memoria del robot: la TMA non le disegna) */
  readonly uscite: readonly Carta[];
  /** gli accusi annunciati in questa smazzata */
  readonly accusi: readonly Accuso[];
  /** le carte pescate in questa smazzata (1v1), col posto */
  readonly pescate: readonly Pescata[];
  /** i segni detti in questa smazzata (2v2), col posto e la presa */
  readonly segni: readonly SegnoDetto[];
  /** i punti di partita delle linee alla fine della smazzata precedente */
  readonly puntiPartita: readonly number[];
  readonly riepiloghi: readonly Riepilogo[];
  readonly vincitore: Linea | null;
}

/** L'esito della partita, come sta in `esito.dettaglio` (`regole.ts` del game host: `{ come, riepiloghi, motivoUscita? }`); `esito.motivo` e `traguardo` o `abbandono`. */
export type ComeFinita = 'vinco-subito' | 'fine-smazzata' | null;

/** I sotto-codici che il game host puo mettere in `reason` di un rifiuto. La frase la sceglie la TMA. */
export const MOTIVI: readonly string[] = ['CARTA_NON_IN_MANO', 'SEME_OBBLIGATORIO', 'SEGNO_NON_AMMESSO', 'SEGNO_FALSO'];

/** La SOLA azione di una persona: gioca una carta della sua mano, col segno se apre la presa nel 2v2. Le chiavi sono esatte: `carta`, `posto`, `t` (e `segno`). */
export interface AzioneDiPersona {
  t: 'GIOCA';
  posto: Posto;
  carta: Carta;
  segno?: Segno;
}

/** Il grado di una carta (1..10: asso, 2..7, fante 8, cavallo 9, re 10) e il suo seme (0..3). */
export const gradoDi = (c: Carta): number => (c % 10) + 1;
export const semeDi = (c: Carta): number => Math.floor(c / 10);
